import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPANY_DETAILS } from '../content/legalTexts';

// Company name, registered address and registration number for the end of each legal page.
function LegalCompanyDetails() {
  const { t } = useTranslation();
  return (
    <aside className="r4l-legal-company" aria-labelledby="r4l-legal-company-title">
      <h2 id="r4l-legal-company-title">{t('legal.companyDetails', 'Company details')}</h2>
      <address>
        <strong>{COMPANY_DETAILS.name}</strong>
        <span>{COMPANY_DETAILS.address}</span>
        <span>{COMPANY_DETAILS.registration}</span>
      </address>
    </aside>
  );
}

export default LegalCompanyDetails;
